module.exports = __webpack_public_path__ + "media/images/blocked-icon-308e3355.png";